module.exports = __webpack_public_path__ + "img/blog-17.bcfe7d51.webp";